

import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { ArrowLeft } from "lucide-react";
import { VEHICLE_IMAGES } from "../../../../Utils/Vehicleimg";
import useCustomerDetails from "../../../Services/Customer/useCustomerDetails";
import { GlobalContext } from "../../../../Context/GlobalContext";

const VehicleFareCard = ({
  onNext,
  onBack,
  selectedVehicle,
  setSelectedVehicle,
  formData,
  setFormData,
}) => {
  const { car, truck, auto, bike } = VEHICLE_IMAGES;
 const { userCode, userID } = useContext(GlobalContext);
  const {
    computeDistanceRouteApi,
    computeDistanceRouteLoading,
    getFaresApi,
    getFaresLoading,
  } = useCustomerDetails();

 const [fareData, setFareData] = useState({
  twoWheelerFare: 0,
  threeWheelerFare: 0,
  fourWheelerFare: 0,
  miniTruckFare: 0,
});

  const [activeVehicle, setActiveVehicle] = useState("Two Wheeler");
  const [showPayment, setShowPayment] = useState(false);

const [payAt, setPayAt] = useState("Pick Up");
  const [paymentMode, setPaymentMode] = useState("UPI");

  const mapRef = useRef(null);
 const googleMapRef = useRef(null);
const pickupMarkerRef = useRef(null);
const dropMarkerRef = useRef(null);
const routeLineRef = useRef(null);

const [computedRoutePath, setComputedRoutePath] = useState([]);
const [routeDistanceText, setRouteDistanceText] = useState("");
const [routeDurationText, setRouteDurationText] = useState("");

  useEffect(() => {
    const fetchRouteAndFareDetails = async () => {
   
      const sessionUser = JSON.parse(sessionStorage.getItem("user") || "{}");

const customerId =
  userCode ||
  userID ||
  formData?.userCode ||
  formData?.userId ||
  formData?.userid ||
  sessionUser?.userCode ||
  sessionUser?.userid ||
  sessionUser?.userId ||
  "";

      const originLatitude =
        formData?.pickupLatitude ||
        formData?.originLatitude ||
        formData?.pickupLat ||
        formData?.fromLat ||
        formData?.pickupLocation?.lat ||
        formData?.pickupLocation?.latitude ||
        "";

      const originLongitude =
        formData?.pickupLongitude ||
        formData?.originLongitude ||
        formData?.pickupLng ||
        formData?.fromLng ||
        formData?.pickupLocation?.lng ||
        formData?.pickupLocation?.longitude ||
        "";

      const destinationLatitude =
        formData?.dropLatitude ||
        formData?.destinationLatitude ||
        formData?.dropLat ||
        formData?.toLat ||
        formData?.dropLocation?.lat ||
        formData?.dropLocation?.latitude ||
        "";

      const destinationLongitude =
        formData?.dropLongitude ||
        formData?.destinationLongitude ||
        formData?.dropLng ||
        formData?.toLng ||
        formData?.dropLocation?.lng ||
        formData?.dropLocation?.longitude ||
        "";

      if (!customerId) {
        return;
      }

      if (
        !originLatitude ||
        !originLongitude ||
        !destinationLatitude ||
        !destinationLongitude
      ) {
        return;
      }

      const routeRes = await computeDistanceRouteApi({
        originLatitude,
        originLongitude,
        destinationLatitude,
        destinationLongitude,
        customerId,
      });

      if (!routeRes || routeRes?.responseCode !== "00") {
        return;
      }

      const normalizedRoute = normalizeComputedRoute(routeRes);

setRouteDistanceText(normalizedRoute.distanceText || "");
setRouteDurationText(normalizedRoute.durationText || "");

if (normalizedRoute.path.length > 1) {
  setComputedRoutePath(normalizedRoute.path);
} else {
  setComputedRoutePath([
    {
      lat: Number(originLatitude),
      lng: Number(originLongitude),
    },
    {
      lat: Number(destinationLatitude),
      lng: Number(destinationLongitude),
    },
  ]);
}

    const fareRes = await getFaresApi({
  customerId,
});

const fareList = Array.isArray(fareRes?.data) ? fareRes.data : [];

if (fareRes?.responseCode === "00" && fareList.length > 0) {
  const getFareByVehicleId = (vehicleId) => {
    const matchedFare = fareList.find(
      (fare) => Number(fare?.vehicle_id) === Number(vehicleId),
    );

    return Number(matchedFare?.estimated_fare || 0);
  };

  setFareData({
    twoWheelerFare: getFareByVehicleId(1),
    threeWheelerFare: getFareByVehicleId(2),
    fourWheelerFare: getFareByVehicleId(3),
    miniTruckFare: getFareByVehicleId(4),
  });
}
    };

    fetchRouteAndFareDetails();
  }, [
    formData?.customerId,
    formData?.userId,
    formData?.customer_id,
    formData?.senderMobile,

    formData?.pickupLatitude,
    formData?.originLatitude,
    formData?.pickupLat,
    formData?.fromLat,
    formData?.pickupLocation?.lat,
    formData?.pickupLocation?.latitude,

    formData?.pickupLongitude,
    formData?.originLongitude,
    formData?.pickupLng,
    formData?.fromLng,
    formData?.pickupLocation?.lng,
    formData?.pickupLocation?.longitude,

    formData?.dropLatitude,
    formData?.destinationLatitude,
    formData?.dropLat,
    formData?.toLat,
    formData?.dropLocation?.lat,
    formData?.dropLocation?.latitude,

    formData?.dropLongitude,
    formData?.destinationLongitude,
    formData?.dropLng,
    formData?.toLng,
    formData?.dropLocation?.lng,
    formData?.dropLocation?.longitude,
  ]);

  const faresLoading = computeDistanceRouteLoading || getFaresLoading;

 const vehicles = useMemo(
  () => [
    {
      vehicleId: 1,
      name: "Two Wheeler",
      img: bike,
      price: fareData.twoWheelerFare,
      toll: 0,
      detail: "20 kg • 40 cm • 1 mins",
      best: "Best for small parcels and quick delivery",
    },
    {
      vehicleId: 2,
      name: "Three Wheeler",
      img: auto,
      price: fareData.threeWheelerFare,
      toll: 0,
      detail: "20 kg • 5 ft • 1 mins",
      best: "Best for medium goods and boxes",
    },
    {
      vehicleId: 3,
      name: "Four Wheeler",
      img: car,
      price: fareData.fourWheelerFare,
      toll: 0,
      detail: "20 kg • 3.4 ft • 1 mins",
      best: "Best for safe covered delivery",
    },
    {
      vehicleId: 4,
      name: "Pickup Truck",
      img: truck,
      price: fareData.miniTruckFare,
      toll: 0,
      detail: "20 kg • 5.5 ft • 1 mins",
      best: "Best for heavy and commercial goods",
    },
  ],
  [
    bike,
    auto,
    car,
    truck,
    fareData.twoWheelerFare,
    fareData.threeWheelerFare,
    fareData.fourWheelerFare,
    fareData.miniTruckFare,
  ],
);

const normalizeVehicleName = (vehicle = "") => {
  const value = String(vehicle).trim().toLowerCase();

  if (value === "1") return "Two Wheeler";
  if (value === "2") return "Three Wheeler";
  if (value === "3") return "Four Wheeler";
  if (value === "4") return "Pickup Truck";

  if (
    value.includes("two") ||
    value.includes("2 wheeler") ||
    value.includes("bike")
  ) {
    return "Two Wheeler";
  }

  if (
    value.includes("three") ||
    value.includes("3 wheeler") ||
    value.includes("auto")
  ) {
    return "Three Wheeler";
  }

  if (
    value.includes("four") ||
    value.includes("4 wheeler") ||
    value.includes("eeco") ||
    value.includes("car")
  ) {
    return "Four Wheeler";
  }

  if (
    value.includes("mini") ||
    value.includes("truck") ||
    value.includes("pickup")
  ) {
    return "Pickup Truck";
  }

  return "Two Wheeler";
};
  
  const orderedVehicles = useMemo(() => {
    const selectedName = normalizeVehicleName(
      selectedVehicle || sessionStorage.getItem("selectedVehicle") || "",
    );

    const selected = vehicles.find((vehicle) => vehicle.name === selectedName);
    const others = vehicles.filter((vehicle) => vehicle.name !== selectedName);

    return selected ? [selected, ...others] : vehicles;
  }, [selectedVehicle, vehicles]);

  useEffect(() => {
    setActiveVehicle(orderedVehicles[0]?.name || "Two Wheeler");
  }, [orderedVehicles]);

 const selectedVehicleData =
  orderedVehicles.find((vehicle) => vehicle.name === activeVehicle) ||
  orderedVehicles[0] ||
  vehicles[0] ||
  null;

 const fare = useMemo(() => {
  const tripFare = Number(selectedVehicleData?.price || 0);
  const tollCharges = Number(selectedVehicleData?.toll || 0);
  const netFare = tripFare + tollCharges;

  return {
    tripFare,
    tollCharges,
    netFare,
    amountPayable: netFare,
  };
}, [selectedVehicleData]);

  const cleanNumber = (value, fallback) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
};

const pickupLocation = useMemo(() => {
  return {
    lat: cleanNumber(
      formData?.pickupLatitude ||
        formData?.pickupLat ||
        formData?.pickup_latitude,
      28.6139,
    ),
    lng: cleanNumber(
      formData?.pickupLongitude ||
        formData?.pickupLng ||
        formData?.pickup_longitude,
      77.209,
    ),
  };
}, [formData]);

const dropLocation = useMemo(() => {
  return {
    lat: cleanNumber(
      formData?.dropLatitude ||
        formData?.dropLat ||
        formData?.drop_latitude,
      pickupLocation.lat + 0.018,
    ),
    lng: cleanNumber(
      formData?.dropLongitude ||
        formData?.dropLng ||
        formData?.drop_longitude,
      pickupLocation.lng + 0.018,
    ),
  };
}, [formData, pickupLocation]);

  function decodePolyline(str) {
  let index = 0,
    lat = 0,
    lng = 0,
    coordinates = [];

  while (index < str.length) {
    let b,
      shift = 0,
      result = 0;

    do {
      b = str.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);

    let dlat = result & 1 ? ~(result >> 1) : result >> 1;
    lat += dlat;

    shift = 0;
    result = 0;

    do {
      b = str.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);

    let dlng = result & 1 ? ~(result >> 1) : result >> 1;
    lng += dlng;

    coordinates.push({ lat: lat / 1e5, lng: lng / 1e5 });
  }

  return coordinates;
}

const normalizeComputedRoute = (apiResponse) => {
  const data =
    apiResponse?.response ||
    apiResponse?.data ||
    apiResponse?.result ||
    apiResponse ||
    {};

  const routeData = Array.isArray(data) ? data[0] : data;

  const encodedPolyline =
  routeData?.routes?.[0]?.polyline?.encodedPolyline ||
  routeData?.routes?.[0]?.overviewPolyline?.encodedPolyline ||
  routeData?.routes?.[0]?.overview_polyline?.points ||
  routeData?.encodedPolyline ||
  routeData?.polyline?.encodedPolyline ||
  routeData?.polyline ||
  "";

  const distanceText =
    routeData?.distanceText ||
    routeData?.distance ||
    routeData?.routes?.[0]?.distanceText ||
    routeData?.routes?.[0]?.legs?.[0]?.distance?.text ||
    "";

  const durationText =
    routeData?.durationText ||
    routeData?.duration ||
    routeData?.routes?.[0]?.durationText ||
    routeData?.routes?.[0]?.legs?.[0]?.duration?.text ||
    "";

  let finalPath = [];

  if (
    encodedPolyline &&
    window.google?.maps?.geometry?.encoding?.decodePath
  ) {
    finalPath = window.google.maps.geometry.encoding
      .decodePath(encodedPolyline)
      .map((point) => ({
        lat: point.lat(),
        lng: point.lng(),
      }));
  }

  return {
    path: finalPath,
    distanceText,
    durationText,
  };
};

const loadGoogleMap = () => {
  const googleKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  if (!googleKey) {
    console.error("Google Maps API key missing in .env");
    return;
  }

  if (window.google?.maps) {
    initMap();
    return;
  }

  const existingScript = document.getElementById("google-maps-script");

  if (existingScript) {
    existingScript.addEventListener("load", initMap);
    return;
  }

  const script = document.createElement("script");
  script.id = "google-maps-script";
  script.src = `https://maps.googleapis.com/maps/api/js?key=${googleKey}&libraries=geometry`;
  script.async = true;
  script.defer = true;
  script.onload = initMap;

  document.body.appendChild(script);
};

const initMap = () => {
  if (!mapRef.current || !window.google?.maps) return;

  if (!googleMapRef.current) {
    googleMapRef.current = new window.google.maps.Map(mapRef.current, {
      center: pickupLocation,
      zoom: 14,
      disableDefaultUI: true,
      zoomControl: true,
      fullscreenControl: true,
      streetViewControl: false,
      mapTypeControl: false,
    });
  }

  renderMap();
};

const clearMapItems = () => {
  if (pickupMarkerRef.current) pickupMarkerRef.current.setMap(null);
  if (dropMarkerRef.current) dropMarkerRef.current.setMap(null);
  if (routeLineRef.current) routeLineRef.current.setMap(null);
};

const renderMap = () => {
  if (!window.google?.maps || !googleMapRef.current) return;

  const map = googleMapRef.current;

  clearMapItems();

  const pickupAddress = formData?.pickupAddress || "Pickup address not added";
  const dropAddress = formData?.dropAddress || "Drop address not added";

  const pickupInfoWindow = new window.google.maps.InfoWindow({
    content: `
      <div style="font-family: Arial; max-width: 240px;">
        <div style="font-size: 13px; font-weight: 700; color: #1f2937; margin-bottom: 4px;">
          Pickup Address
        </div>
        <div style="font-size: 12px; line-height: 18px; color: #4b5563;">
          ${pickupAddress}
        </div>
      </div>
    `,
  });

  const dropInfoWindow = new window.google.maps.InfoWindow({
    content: `
      <div style="font-family: Arial; max-width: 240px;">
        <div style="font-size: 13px; font-weight: 700; color: #1f2937; margin-bottom: 4px;">
          Drop Address
        </div>
        <div style="font-size: 12px; line-height: 18px; color: #4b5563;">
          ${dropAddress}
        </div>
      </div>
    `,
  });

  pickupMarkerRef.current = new window.google.maps.Marker({
    map,
    position: pickupLocation,
    title: "Pickup Location",
    label: {
      text: "P",
      color: "#ffffff",
      fontWeight: "700",
    },
    icon: {
      path: window.google.maps.SymbolPath.CIRCLE,
      scale: 13,
      fillColor: "#2563eb",
      fillOpacity: 1,
      strokeColor: "#ffffff",
      strokeWeight: 4,
    },
  });

  dropMarkerRef.current = new window.google.maps.Marker({
    map,
    position: dropLocation,
    title: "Drop Location",
    label: {
      text: "D",
      color: "#ffffff",
      fontWeight: "700",
    },
    icon: {
      path: window.google.maps.SymbolPath.CIRCLE,
      scale: 13,
      fillColor: "#16a34a",
      fillOpacity: 1,
      strokeColor: "#ffffff",
      strokeWeight: 4,
    },
  });

  pickupMarkerRef.current.addListener("mouseover", () => {
    dropInfoWindow.close();
    pickupInfoWindow.open(map, pickupMarkerRef.current);
  });

  pickupMarkerRef.current.addListener("mouseout", () => {
    pickupInfoWindow.close();
  });

  dropMarkerRef.current.addListener("mouseover", () => {
    pickupInfoWindow.close();
    dropInfoWindow.open(map, dropMarkerRef.current);
  });

  dropMarkerRef.current.addListener("mouseout", () => {
    dropInfoWindow.close();
  });

  const finalRoutePath =
    computedRoutePath && computedRoutePath.length > 1
      ? computedRoutePath
      : [pickupLocation, dropLocation];

  routeLineRef.current = new window.google.maps.Polyline({
    map,
    path: finalRoutePath,
    geodesic: true,
    strokeColor: "#2563eb",
    strokeOpacity: 0.95,
    strokeWeight: 5,
  });

  const bounds = new window.google.maps.LatLngBounds();

  bounds.extend(pickupLocation);
  bounds.extend(dropLocation);

  if (computedRoutePath?.length > 1) {
    computedRoutePath.forEach((point) => {
      bounds.extend(point);
    });
  }

  map.fitBounds(bounds);

  setTimeout(() => {
    if (map.getZoom() > 15) {
      map.setZoom(15);
    }
  }, 300);
};

useEffect(() => {
  loadGoogleMap();
}, []);

useEffect(() => {
  if (window.google?.maps && googleMapRef.current) {
    renderMap();
  }
}, [pickupLocation, dropLocation, computedRoutePath]);

  const handleVehicleSelect = (vehicleName) => {
    setActiveVehicle(vehicleName);

    sessionStorage.setItem("selectedVehicle", vehicleName);

    if (setSelectedVehicle) {
      setSelectedVehicle(vehicleName);
    }
  };

  return (
    <section className="w-full px-3 pb-6 pt-8 sm:px-4 md:px-6 md:pt-12 lg:px-0 lg:pt-0">
      <div className="mx-auto mt-10 grid w-full max-w-[1020px] overflow-hidden rounded-[26px] border border-white/80 bg-white shadow-[0_22px_70px_rgba(15,23,42,0.16)] sm:mt-4 md:mt-10 lg:mt-[120px] lg:grid-cols-[57%_43%]">
        {/* LEFT */}
        <div className="order-2 flex flex-col bg-white px-4 py-6 sm:px-6 sm:py-8 md:px-8 lg:order-1 lg:px-7 lg:py-5">
          <div className=" w-full max-w-[580px]">
            {/* BACK */}
            <button
              type="button"
              onClick={onBack}
              className="mb-4 inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50"
            >
              <ArrowLeft size={17} />
              Back to Address
            </button>

            {/* CONTACT INFO */}
            <div className="mb-4 overflow-hidden rounded-lg border border-gray-200 bg-white">
              <h3 className="border-b px-4 py-3 text-[18px] text-gray-800">
                Contact Details
              </h3>

              <div className="grid grid-cols-1 gap-3 px-4 py-4 text-sm sm:grid-cols-2">
                <div>
                  <p className="text-gray-400">Sender</p>
                  <p className="font-semibold text-gray-800">
                    {formData?.senderName || "-"}
                  </p>
                  <p className="text-gray-500">
                    {formData?.senderMobile || "-"}
                  </p>
                </div>

                <div>
                  <p className="text-gray-400">Receiver</p>
                  <p className="font-semibold text-gray-800">
                    {formData?.receiverName || "-"}
                  </p>
                  <p className="text-gray-500">
                    {formData?.receiverMobile || "-"}
                  </p>
                </div>
              </div>
            </div>

            {/* FARE SUMMARY */}
            <div className="mb-4 overflow-hidden rounded-lg border border-gray-200 bg-white">
              <h3 className="border-b px-4 py-3 text-[18px] text-gray-800">
                Fare Summary
              </h3>

              <div className="space-y-2 px-4 lg:pt-4 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-500">Selected Vehicle</span>
                  <span className="font-bold text-gray-800">
                  {selectedVehicleData?.name || "-"}
                  </span>
                </div>

                <div className="flex justify-between">
                  <span className="text-gray-500">Trip Fare</span>
                  <span className="font-bold text-gray-800">
                    ₹ {fare.tripFare.toFixed(2)}
                  </span>
                </div>

                <div className="flex justify-between">
                  <span className="text-gray-500">
                    Toll Charges
                    <span className="ml-1 rounded-full bg-orange-100 px-1.5 py-0.5 text-[9px] text-orange-500">
                      include
                    </span>
                  </span>

                  <span className="font-bold text-gray-800">
                    ₹ {fare.tollCharges.toFixed(2)}
                  </span>
                </div>

                <div className="flex justify-between">
                  <span className="text-gray-500">Net Fare</span>
                  <span className="font-bold text-gray-800">
                    ₹ {fare.netFare.toFixed(2)}
                  </span>
                </div>

                <div className="flex justify-between border-t py-2">
                  <span className="font-bold text-gray-500">
                    Amount Payable
                  </span>
                  <span className="font-bold text-gray-800">
                    ₹ {fare.amountPayable.toFixed(2)}
                  </span>
                </div>
              </div>
            </div>

            {/* PAYMENT */}
<div className="mb-6 overflow-hidden rounded-lg border border-gray-200 bg-white">
  <div className="border-b px-4 py-3">
    <h3 className="text-[18px] font-semibold text-gray-800">
      Select Payment Mode
    </h3>
  </div>
  

  <button className="flex w-full items-center justify-between px-4 py-3 hover:bg-gray-50">
    <span className="font-medium text-gray-700">UPI</span>
    <span className="text-sm text-gray-400">
      Google Pay / PhonePe
    </span>
  </button>

  <button className="flex w-full items-center justify-between border-t px-4 py-3 hover:bg-gray-50">
    <span className="font-medium text-gray-700">
      Cash on Delivery
    </span>
    <span className="text-sm text-gray-400">
      Pay after delivery
    </span>
  </button>

  <button className="flex w-full items-center justify-between border-t px-4 py-3 hover:bg-gray-50">
    <span className="font-medium text-gray-700">
      Debit / Credit Card
    </span>
    <span className="text-sm text-gray-400">
      Visa, Mastercard
    </span>
  </button>
</div>
</div>
{/* Pay At Toggle */}
 <div className="flex items-center mb-6 justify-between rounded-lg border border-gray-200 bg-white px-4 py-3">
        
        <span className="text-[16px] font-semibold text-gray-800">
          Pay At
        </span>

        <div className="flex rounded-full bg-gray-100 p-1">
          
          <button
            onClick={() => setPayAt("Pick Up")}
            className={`rounded-full px-4 py-1 text-sm font-medium transition ${
              payAt === "Pick Up"
                ? "bg-white text-gray-800 shadow"
                : "text-gray-500 hover:text-gray-800"
            }`}
          >
            Pick Up
          </button>

          <button
            onClick={() => setPayAt("Drop")}
            className={`rounded-full px-4 py-1 text-sm font-medium transition ${
              payAt === "Drop"
                ? "bg-white text-gray-800 shadow"
                : "text-gray-500 hover:text-gray-800"
            }`}
          >
            Drop
          </button>

        </div>
      </div>
          {/* BOTTOM BUTTON */}
          <div
            className={`w-full max-w-[580px] transition-all duration-300 ${
              showPayment ? "mt-0" : "mt-2"
            }`}
          >
          <button
  type="button"
  onClick={() => {
    if (onNext) {
      onNext({
       selectedVehicle: selectedVehicleData?.name || activeVehicle || "Two Wheeler",
        baseFare: Number(fare.tripFare || 0),
        tripFare: Number(fare.tripFare || 0),
        tollCharges: Number(fare.tollCharges || 0),
        netFare: Number(fare.netFare || 0),
        amountPayable: Number(fare.amountPayable || 0),
      });
    }
  }}
  className="w-full rounded-lg bg-[#1f2d3f] py-3 font-semibold text-white transition hover:opacity-90"
>
  Driver is on the Way
</button>
          </div>
        </div>

        {/* RIGHT */}
        <div className="order-1 lg:order-2 flex flex-col">
<div className="order-1 flex h-[420px] bg-slate-100 p-4 sm:h-[460px] md:h-[500px] lg:order-2 lg:h-full lg:p-5">
            <div className="relative h-full w-full overflow-hidden rounded-3xl border border-white/70 bg-white shadow-inner">
              <div ref={mapRef} className="h-full w-full" />
            </div>
          </div>

        <div className="order-1 bg-[#fbf6e7] px-4 py-6 sm:px-6 sm:py-8 lg:order-2 lg:px-7 lg:py-5">
          <div className="mx-auto max-w-[420px]">
            <h4 className="mb-3 text-base font-bold text-gray-500">
              Recommended Vehicles
            </h4>

            <div className="space-y-4">
              {orderedVehicles.map((vehicle) => (
                <div
                  key={vehicle.name}
                  onClick={() => handleVehicleSelect(vehicle.name)}
                  className={`cursor-pointer overflow-hidden rounded-lg border bg-white transition ${
                    activeVehicle === vehicle.name
                      ? "border-orange-400 bg-orange-100"
                      : "border-gray-200 hover:border-orange-200"
                  }`}
                >
                  <div
                    className={`flex items-center justify-between px-4 py-1 ${
                      activeVehicle === vehicle.name
                        ? "bg-orange-100"
                        : "bg-white"
                    }`}
                  >
                    <div className="flex items-center gap-4">
                      <div className="flex h-16 w-16 items-center justify-center">
                        <img
                          src={vehicle.img}
                          alt={vehicle.name}
                          className="h-12 w-12 object-contain"
                        />
                      </div>

                      <div>
                        <h3 className="font-bold text-gray-800">
                          {vehicle.name}
                        </h3>

                        {activeVehicle === vehicle.name ? (
                          <div className="text-sm leading-5 text-gray-600">
                            <p>
                              <b>Weight:</b> Up to 20 kg
                            </p>
                            <p>
                              <b>Dimension:</b> H-40 cm x W-40 cm x L-40 cm
                            </p>
                          </div>
                        ) : (
                          <p className="text-sm text-gray-500">
                            {vehicle.detail}
                          </p>
                        )}
                      </div>
                    </div>

                    <h3 className="self-start text-[18px] font-bold text-gray-900 sm:self-center sm:text-[20px]">
                  ₹{Number(vehicle.price || 0).toFixed(2)}
                    </h3>
                  </div>

                  {activeVehicle === vehicle.name && (
                    <div className="border-t border-orange-300 bg-white px-4 py-3 text-sm text-gray-500">
                      {vehicle.best}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      </div>
    </section>
  );
};

export default VehicleFareCard;